import PropTypes from "prop-types";
import lodashGet from "lodash.get";

const AdobeAppMeasurement = props => {
  // eslint-disable-next-line no-undef
  if (!lodashGet(global, "window")) {
    return;
  }

  window.adobeAnalyticsMethods = window.adobeAnalyticsMethods || {};
  window.adobeAnalyticsMethods.pageViewCreateAppMeasurement = function(
    appMeasurement
  ) {
    return appMeasurement;
  };

  window.adobeAnalyticsMethods.resetProductAndSearchAnalytics = function(
    appMeasurement,
    isPdp
  ) {
    if (isPdp) {
      appMeasurement.events = "event13,prodView";
    } else {
      appMeasurement.products = undefined;
    }
    appMeasurement.eVar30 = undefined; // query (alias: onSiteSearchTerm)
    appMeasurement.eVar31 = undefined; // nbHits (alias: onSiteSearchResults)
    return appMeasurement;
  };

  // This function provides a standard way to prepare the details of the list of products for passing in the tag
  window.adobeAnalyticsMethods.transferProductDetailsFromGivenObject = function(
    appMeasurement,
    details
  ) {
    // Set events and clear eVars
    appMeasurement = window.adobeAnalyticsMethods.resetProductAndSearchAnalytics(
      appMeasurement,
      true
    );

    // Define the variable to prevent errors
    appMeasurement.products = "";

    // Loop through the data layer products array and build s.products to include just SKUS
    try {
      for (let i = 0; i < details.product.length; i++) {
        appMeasurement.products =
          appMeasurement.products +
          ";" +
          (details.product[i].productInfo.productID || "") +
          ";;;;eVar19=" +
          (details.product[i].productInfo.dinkus || "none") +
          "|eVar20=" +
          (details.product[i].productInfo.rating || "") +
          "|eVar41=" +
          (details.product[i].productInfo.bundleSlot || "") +
          "|eVar54=" +
          (details.product[i].attributes.webHierarchy || "").replace(",", "_") +
          ",";
      }
    } catch (error) {
      console.error(error);
    }

    return appMeasurement;
  };

  window.adobeAnalyticsMethods.buildDataLayerForAddToCart = (
    appMeasurement,
    details
  ) => {
    appMeasurement = window.adobeAnalyticsMethods.transferProductDetailsFromGivenObject(
      appMeasurement,
      details.addToCart
    );
    //make sure the s.tl beacon knows to pick up the products variable in addition to variables set directly in the rule interface
    appMeasurement.linkTrackVars =
      appMeasurement.linkTrackVars + ",products,events";
    appMeasurement.linkTrackEvents =
      appMeasurement.linkTrackVars + "scOpen,scAdd";
    appMeasurement.events = "scAdd";
    //Empty Cart
    try {
      if (
        lodashGet(props, "_satellite.getVar") &&
        props._satellite.getVar("events") &&
        props._satellite.getVar("events").indexOf("scOpen") > -1
      ) {
        appMeasurement.events = appMeasurement.apl(
          appMeasurement.events,
          "scOpen,scAdd",
          ",",
          1
        );
        //Non Empty Cart
      } else if (
        lodashGet(props, "_satellite.getVar") &&
        props._satellite.getVar("events") &&
        props._satellite.getVar("events").indexOf("scOpen") < 0
      ) {
        appMeasurement.events = appMeasurement.apl(
          appMeasurement.events,
          "scAdd",
          ",",
          1
        );
      }
    } catch (error) {
      console.error(error);
    }
    return appMeasurement;
  };

  return null;
};

AdobeAppMeasurement.propTypes = {
  _satellite: PropTypes.object,
  digitalData: PropTypes.object
};

AdobeAppMeasurement.defaultProps = {
  // eslint-disable-next-line no-undef
  digitalData: lodashGet(global, "digitalData"),
  // eslint-disable-next-line no-undef
  _satellite: lodashGet(global, "_satellite")
};

export default AdobeAppMeasurement;
